import { Input } from "reactstrap";
import PropTypes from "prop-types";

const ContainerOpciones = ({ opciones, onBuscar, tipo = "turnos" }) => {
    const placeholder =
        tipo == "turnos" ? "Sigla del turno" : "Nombre de la actividad";

    return (
        <div id={`opciones-${tipo}`}>
            {onBuscar && (
                <section className="buscador-container">
                    <Input
                        id="buscador"
                        type="search"
                        placeholder={placeholder}
                        onInput={onBuscar}
                        autoComplete="off"
                    />
                </section>
            )}
            <div className="opciones">
                <ul className={`lista-opciones-${tipo}`}>{opciones}</ul>
            </div>
        </div>
    );
};

ContainerOpciones.propTypes = {
    opciones: PropTypes.array,
    onBuscar: PropTypes.func,
    tipo: PropTypes.string,
};

export default ContainerOpciones;
